import {createContext} from "react";


export const PriceTypesContent = createContext(null)